<template>
  <main class="safe_service_pop_wrap">
    <div
      data-v-05ab5af4=""
      class="modal_wrap bottom_modal"
      autoestimation=""
      :class="{ on: isOpen }"
    >
      <div class="modal_inner" @click.self="$emit('close')">
        <div class="modal">
          <!-- <div class="safe_modal_close" @click="$emit('close')">
            <img :src="require('@/assets/front/images/new/i_x_w.png')" alt="" />
          </div> -->
          <div class="safe_service_pop">
            <div class="pop_content">
              <div class="info_img">
                <img
                  :src="
                    require('@/assets/front/images/new/img_txt_noti_hand.png')
                  "
                  alt=""
                />
              </div>
              <div class="info_title" v-if="promotion == 'KT'">
                간편하고 안전한 <br />
                KT인터넷+TV 가입안내
              </div>
              <div class="info_title" v-else>
                <span>안전한 거래</span>를 위한 채팅상담 <span>TIP</span>!
              </div>
              <div class="info_con_wrap">
                <div class="info_con con_btm">
                  <div class="con_title">1. 대화 내용 공유 (퍼스 공증)</div>
                  <div class="con_txt">
                    퍼스 관리자에게 대화를 공유하여 분쟁 발생시 퍼스의 도움을
                    받을 수 있는 안심 서비스입니다.
                  </div>
                </div>
                <div class="info_con" v-if="promotion == 'KT'">
                  <div class="con_title">
                    2. 간편한 본인인증과 설치일정 예약
                  </div>
                  <div class="con_txt">
                    상담 후 본인인증과 설치 일정을 채팅 내에서 간편하게 진행하실
                    수 있습니다. 별도의 복잡한 절차 없이 빠르게 처리해 드립니다.
                  </div>
                </div>
                <div class="info_con" v-else>
                  <div class="con_title">
                    2. 직거래는 NO! 가입신청서 이용하기!
                  </div>
                  <div class="con_txt">
                    상담 후 가입 결정을 하였다면 채팅 입력창 위의 인터넷
                    가입신청서를 작성해 주세요! 가입신청서가 아닌 직거래는 분쟁
                    시 퍼스의 도움을 받을 수 없어요!
                  </div>
                </div>
              </div>
              <div class="ttl_info">
                ※거래목적이 아닌 <span>채증활동</span>이나
                <span>비방.욕설</span> 그리고
                <span>가입 후 의무사용기한 미준수 등 특약사항 위배</span> 등의
                <span>상도의에 어긋난 행위</span> 발생 시 법적조치 등에 필요한
                개인정보가 해당매장에 제공될 수 있습니다
              </div>
            </div>
            <div class="btm_btn">
              <div class="btn_wrap">
                <button class="btn" @click.once="agreeChat">
                  동의하고 채팅하기
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';

// Import Swiper styles
import 'swiper/swiper.scss';

// import Swiper core and required modules

import { mapActions as commonMapActions } from '@common/store/modules/common';
import * as commonActions from '@common/store/modules/common/types';
import {
  mapActions,
  mapState,
  mapMutations,
  mapGetters,
} from '@common/store/modules/shop';
import * as shopTypes from '@common/store/modules/shop/types';
import {
  mapActions as chatMapActions,
  mapState as chatMapState,
  mapGetters as chatMapGetters,
} from '@common/store/modules/chat';
import * as chatActions from '@common/store/modules/chat/types';
import * as chatGetters from '@common/store/modules/chat/getters';
import {
  mapActions as estimateMapActions,
  mapGetters as estimateMapGetters,
} from '@common/store/modules/estimate';
import * as estimationTypes from '@common/store/modules/estimate/types';
import { authMapGetters, authGetters } from '@common/store/modules';

import KeywordBenefit from '@/common/components/keyword/BenefitMini.vue';
import Reviews from '@/front/customer/views/shops/components/Reviews.vue';

import ImageModal from '@/front/customer/views/shops/modal/ImageModal';
import {
  checkMobileOperatingSystem,
  setCallbackOnClickBackKey,
  nativeEnableBackKey,
  nativeDisableBackKey,
} from '@common/lib/common/utils';

import {
  mapActions as reviewMapActions,
  mapGetters as reviewMapGetters,
} from '@common/store/modules/review';
import * as reviewTypes from '@common/store/modules/review/types';
import { sleep, nativeDeviceInfo } from '@common/lib/common/utils';
import Vue from 'vue';
export default {
  name: 'safePhoneModal',
  components: {},
  data() {
    return {
      isOpen: false,
      promotion: '',
      safeNumber: '',
      timeValue: '모든 시간',
    };
  },
  computed: {},
  methods: {
    normalChat() {
      this.$emit('normalChat');
    },
    agreeChat() {
      this.$emit('agreeChat');
    },
  },
};
</script>
